module.exports = __webpack_public_path__ + "assets/push-redpack-0a0377f1.png";